export default {
    input: function(name) {
        return document.querySelector(`[name="${name}"]`);
    },
    inputCol: function(name) {
        return document.querySelector(`[data-field-name="${name}"]`);
    },
    option: function(value) {
        return document.querySelector(`option[value="${value}"]`);
    },
    section: function(name) {
        return document.querySelector(`[data-section="${name}"]`);
    },
    button: function(name) {
        return document.querySelector(`[data-button="${name}"]`);
    },
    style: {
        backgroundColor: function(name) {
            return document.documentElement.style.getPropertyValue(name);
        },
        color: {
            outline: function(name) {
                return document.documentElement.style.getPropertyValue(
                    `--outline-${name}`
                );
            },
            button: function(name) {
                return document.documentElement.style.getPropertyValue(
                    `--button-${name}`
                );
            }
        }
    }
};
